import { useEffect, useState } from "react";

import { getGroups } from "../services/accountManagement.service";
import { GroupInfo } from "../types/accountManagement.types";

interface UseGroupsResult {
  groups: GroupInfo[];
  loading: boolean;
  error: string | null;
}

export const useGroups = (): UseGroupsResult => {
  const [groups, setGroups] = useState<GroupInfo[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    getGroups()
      .then((response) => {
        if (!cancelled) setGroups(response.groups);
      })
      .catch(() => {
        if (!cancelled) setError("Failed to load access groups.");
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return { groups, loading, error };
};
